import { httpRequest } from "@/lib";
import { useQuery } from "@tanstack/react-query";
import { AgreementsResponse, AgreementsResponseNoPagination } from "@/types";
import { GET_AGREEMENTS } from "./routes";

type Props = {
  search?: string;
};

async function fetchAgreements({
  search = "",
}: Props): Promise<AgreementsResponse> {
  const response = await httpRequest.get<AgreementsResponse>(
    `${GET_AGREEMENTS}?search=${search}`
  );
  return response.data;
}

export function useFetchAgreementsQuery(props: Props) {
  const covenantssQuery = useQuery({
    queryKey: ["agreements", props],
    queryFn: () => fetchAgreements(props),
    keepPreviousData: true,
  });

  return {
    ...covenantssQuery,
    data: covenantssQuery?.data,
  };
}

async function fetchAgreementsNoPaginate(): Promise<AgreementsResponseNoPagination> {
  const response = await httpRequest.get<AgreementsResponseNoPagination>(
    GET_AGREEMENTS
  );
  return response.data;
}

export function useFetchAgreementsNoPaginateQuery() {
  const covenantsQuery = useQuery({
    queryKey: ["agreements"],
    queryFn: () => fetchAgreementsNoPaginate(),
    keepPreviousData: true,
  });

  return {
    ...covenantsQuery,
    data: covenantsQuery?.data,
  };
}
